module.exports = __webpack_public_path__ + "media/images/area/icon_weather_22-625b9a6bd636a2c6ffa599f9de9ad3d9.png";